import { Route, Redirect } from "react-router-dom";
import LocalStorageService from "../utils/localStorageServices";
import QueryProvider from "../lib/query-provider";

const localStorageServices = LocalStorageService.getService();

const MiddleWare = ({
  component: Component,
  layout: Layout,
  path,
  ...rest
}) => {
  const currentUser = localStorageServices.getCurrentUser();
  const isValid = currentUser != null;

  const authRoutes = [
    "/",
    "/verifyAccount",
    "/signup",
    "/forgotpassword",
    "/verifypassword" // ❗ fixed missing slash
  ];

  return (
    <Route
      {...rest}
      render={({ location }) => {
        console.log("Current path:", location.pathname);

        const isAuthRoute = authRoutes.includes(location.pathname);

        return isValid && !isAuthRoute ? (
          <Layout>
            <QueryProvider>
              <Component currentUser={currentUser} />
            </QueryProvider>
          </Layout>
        ) : (
          <Redirect
            to={{
              pathname: "/",
              state: { from: location, redirectTo: path }
            }}
          />
        );
      }}
    />
  );
};

export default MiddleWare;
